






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Menu from '@/components/Menu.vue';
import ArrowDown from '@/components/ArrowDown.vue';
@Component({
  components: {
    Menu,
    ArrowDown,
  },
  computed: mapState(['isMobole', 'seriesType']),
})
export default class Index extends Vue {
  isMobole!: Boolean;

  mounted() {
    console.log('shouji', this.isMobole);
  }
  toRouter(i) {
    this.$store.commit('setCurrentPage', i);
  }
  mainRou() {
    if (window.location.host === 'test.fnws.top') {
      window.location.replace('https://test.fnws.top/Porsche-Productandservice/');
    } else {
      window.location.replace(
        'https://aftersales.porsche-cloud.com/productandservice/?utm_source=windowfilm&utm_medium=allinone',
      );
    }
  }
}
